import { DomainRule } from '../../types';

export const WebContentNameRequiredRuleKey = 'webContentNameRequired';
export const WebContentNameCharLimit = 'webContentNameCharLimit';

export const DisplayWebContentNameRequiredRule = ({ name }: { name: string }): DomainRule => {
  const trimmedNames = name?.trim();
  if (!trimmedNames) {
    return {
      result: 'fail',
      ruleKey: WebContentNameRequiredRuleKey,
    };
  }

  const namesTooLong = trimmedNames?.length > 100;
  if (namesTooLong) {
    return {
      result: 'fail',
      ruleKey: WebContentNameCharLimit,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
